import React from 'react';
import * as FPT from '../utility/fpt';
import { blue600, BodyText, grey600 } from '@paypalcorp/pp-react';
import getSocialCampaign from '../utility/getSocialCampaign';
import TemplateData, { localsMessages } from '../utility/getTemplateData';
import SocialShare from '../components/socialShare/socialShare';
import _isEmpty from 'lodash/isEmpty';
import { isInContext } from '../utility/inContextDonation';
import { isExternalFlow } from '../utility/externalIntegrationUtils';
import { EVENT_NAME } from '../utility/constants';
import classNames from 'classnames';

const { label: copyLinkMessages } = localsMessages('common/copyLink');
const { title = {}, sheet = {} } = localsMessages('common/socialShareMessage');

export default function ConfirmationSocialShare(props) {
  const {
    email,
    hostedButtonId,
    orgName,
    messages: { social },
    personalizedMessages,
  } = props;
  const { copy, copied } = copyLinkMessages;
  const handleSocialAnalytics = (type) => {
    if (isExternalFlow()) {
      FPT.trackLinkClickWithData(type, {
        event_name: EVENT_NAME.DW_GIVING_SHARE_CHANNEL_PRESSED,
      });
    } else {
      FPT.trackLinkClick(type);
    }
  };

  let socialMessages;

  if (personalizedMessages) {
    socialMessages = {
      ...social,
      ...personalizedMessages,
      copyLinkCopy: copy,
      copyLinkCopied: copied,
      sheet,
    };
  } else if (hostedButtonId) {
    socialMessages = {
      ...social,
      copyLinkCopy: copy,
      copyLinkCopied: copied,
      sheet,
    };
  } else {
    socialMessages = {
      ...social,
      ...social.unhosted,
      copyLinkCopy: copy,
      copyLinkCopied: copied,
      sheet,
    };
  }

  const socialCampaign = getSocialCampaign(
    socialMessages,
    orgName,
    hostedButtonId,
    title,
    email
  );

  const getSocialShareHeader = () => {
    if (personalizedMessages.social_title) {
      return personalizedMessages.social_title;
    } else if (_isEmpty(personalizedMessages)) {
      return TemplateData.pxp.shareContentExp.experiment
        ? social.shareWithMatch
        : social.shareGeneric;
    }
  };

  const generateSocialShareUrl = () => {
    if (isExternalFlow()) {
      return TemplateData.shareUrl;
    } else if (hostedButtonId) {
      return `https://www.paypal.com/donate/?hosted_button_id=${hostedButtonId}&source=url`;
    } else if (email) {
      return `https://www.paypal.com/donate/?business=${email}&source=url`;
    }
  };

  const socialShareUrl = generateSocialShareUrl();

  const colors = {
    facebook: '#007AFF',
    twitter: '#64D2FF',
  };

  const headerClasses = classNames('text-center', 'social_share_header', {
    inContext: isInContext(),
    externalFlow: isExternalFlow(),
  });

  return (
    <>
      <BodyText className={headerClasses}>{getSocialShareHeader()}</BodyText>
      {TemplateData.ismobile && isExternalFlow() ? (
        <SocialShare
          shareUrl={socialShareUrl}
          socialCampaign={socialCampaign}
          isMobile={TemplateData.ismobile}
          analytics={handleSocialAnalytics}
          color={colors}
          style={{ marginBottom: '20px' }}
          renderMode="sheet"
          buttonText={personalizedMessages.success_share_button}
        />
      ) : (
        <SocialShare
          shareUrl={socialShareUrl}
          socialCampaign={socialCampaign}
          isMobile={TemplateData.ismobile}
          analytics={handleSocialAnalytics}
          color={isInContext() && isExternalFlow() ? grey600 : blue600}
          style={
            isInContext() && isExternalFlow()
              ? { marginBottom: '28px' }
              : { marginBottom: '60px' }
          }
        />
      )}
    </>
  );
}
